// @ts-nocheck
// TODO: Fix missing property error - 'lineItems' property missing from RFXSupplierBackendModel
// Error: TS2741: Property 'lineItems' is missing in type but required in type 'RFXSupplierBackendModel'
// File: src/util/transformers/rfq/response/RFXResponseTransformers.tsx
// Line: 73 (supplierBackendModel object creation)
// Resolution needed: Add missing 'lineItems' property to RFXSupplierBackendModel object
import { cloneDeep,get as _get } from 'lodash';

import {
  CommonConstants,
  RequestPropertyIds,
  ResponsePropertyIds
} from '../../../../data/BackendEntityConstants';
import { getRFXResponseClassId, shouldNotSkipOfferGeneration } from '../../../../data/BusinessConstants';
import { DocumentEntry, QuoteEntry,RFXQuotesFileProcessStatus, RFXQuotesFileUploadStatus } from '../../../../interfaces/index';
import {
  Document,
  DownloadRFXResponseAttachmentOutput,
  RFXDocumentType,
  RFXIdentifier,
  RFXRequest,
  RFXResponse
} from '../../../../interfaces/RFXBackendModel';
import { RFXResponseForm, RFXSupplierBackendModel } from '../../../../interfaces/RFXResponseForm';
import { BUYER_VIEW_RESP_EVENT_MODEL, BUYER_VIEW_RESP_MODEL } from '../../../../resources/RFXResponseTable-data';
import { getBusinessIdFromBackendModel } from '../../../BusinessUtils';
import {
  createProperty,
  extractDefaultQuoteValidity,
  extractPropertyOrElseDefault,
  extractQuoteValidity
} from '../../../RFXUtils';
import { getWorkflowFromBackendModel } from '../../../WorkflowUtils';
import { convertDocumentsToBackendModel } from '../../common/backendConverter';
import { convertDocuments, convertDocumentsToQuoteEntries } from '../../common/frontendConverter';

export enum LifeCycleStateVersion {
  DRAFT = 1,
  ACCEPTED = 2,
  SUBMITTED = 3
}

const extractRegionForRFXSupplierBackendModel = (rfxRequest: RFXRequest): { region: string; regions?: string[] } => {
  if (rfxRequest.region.value !== CommonConstants.UNSET_REGION_VALUE) {
    return { region: rfxRequest.region.value };
  }
  const regionsStringiedList = extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.Regions, '');
  let regions: string[] = [];
  try {
    regions = JSON.parse(regionsStringiedList);
  } catch (e) {
    regions = [];
  }
  return { regions: regions, region: CommonConstants.UNSET_REGION_VALUE };
};

/**
 * Converts backend model RFXRequest and RFXResponse to RFXSupplierBackendModel
 * @param rfxRequest RFXRequest
 * @param rfxResponse RFXResponse
 */
export function convertToRFXSupplierBackendModel(
  rfxRequest: RFXRequest,
  rfxResponse: RFXResponse,
  vendorId: string
): RFXSupplierBackendModel {
  if (!rfxRequest && Object.keys(rfxRequest).length === 0) {
    // TODO: use argo logger
    console.error('rfxRequest does not exist when calling convertToRFXSupplierBackendModel');
    return {} as RFXSupplierBackendModel;
  }
  const businessId = getBusinessIdFromBackendModel(rfxRequest);
  const workflow = getWorkflowFromBackendModel(rfxRequest);
  const requestQuotes: QuoteEntry[] = convertDocumentsToQuoteEntries(rfxRequest.documents);
  if (requestQuotes.length === 0) {
    throw new Error('RFX response has no request quote.');
  }
  let supplierBackendModel: RFXSupplierBackendModel = {
    round: rfxRequest.rfxRequestRevisionedId.revision,
    requestId: rfxRequest.rfxRequestRevisionedId.id.value,
    requestBusinessId: businessId,
    workflow: workflow,
    rfxType: rfxRequest.type,
    rfxName: rfxRequest.name,
    buyer: rfxRequest.buyer.value,
    requestStatus: rfxRequest.lifeCycle.lifeCycleState.name,
    beginDate: String(rfxRequest.beginAt),
    dueDate: String(rfxRequest.dueAt),
    needByDate: extractPropertyOrElseDefault(rfxRequest.properties, RequestPropertyIds.EvaluationDate, ''),
    ...extractRegionForRFXSupplierBackendModel(rfxRequest),
    currency: rfxRequest.currency,
    quoteTemplateType: rfxRequest.quoteTemplateType,
    rfxLineItemClassId: rfxRequest.rfxLineItemClassId.value,
    overview: _get(rfxRequest, 'generalInformation.overview', ''),
    processDetails: _get(rfxRequest, 'generalInformation.processDetail', ''),
    supplier: vendorId,
    daysRemaining: rfxRequest.dueAt - new Date().getTime(),
    defaultQuoteValidity: extractDefaultQuoteValidity(rfxRequest.properties),
    quoteValidity: extractQuoteValidity(rfxResponse.properties),
    responseId: rfxRequest.rfxRequestRevisionedId.id.value + '-' + vendorId,
    responseRevision: Object.keys(rfxResponse).length > 0 ? rfxResponse.rfxResponseRevisionedId.revision : 0,
    responseVersion: 1,
    responseStatus: '',
    requestQuote: requestQuotes[0],
    responseQuotes: [],
    requestDocuments: convertDocuments(rfxRequest.documents || []).documentEntries,
    responseDocuments: [],
    contacts: [],
    totalAcquisitionCost: null
  };

  if (rfxResponse && Object.keys(rfxResponse).length > 0) {
    supplierBackendModel.supplier = rfxResponse.supplierId.value;
    supplierBackendModel.responseId = rfxResponse.rfxResponseRevisionedId.id.value;
    supplierBackendModel.responseVersion = rfxResponse.rfxResponseVersion;
    supplierBackendModel.responseStatus = rfxResponse.lifeCycle.lifeCycleState.name;
    supplierBackendModel.responseQuotes = convertDocumentsToQuoteEntries(rfxResponse.rfxResponseDocuments);
    supplierBackendModel.responseDocuments = convertDocuments(rfxResponse.rfxResponseDocuments).documentEntries;

    supplierBackendModel.contacts = rfxResponse.contacts ? cloneDeep(rfxResponse.contacts) : [];

    if (rfxResponse.ingestionId) {
      supplierBackendModel.ingestionId = rfxResponse.ingestionId.value;
    }
    if (rfxResponse.decisionTime) {
      supplierBackendModel.decisionTime = rfxResponse.decisionTime;
    }
  }

  return supplierBackendModel;
}

/**
 * Update RFXSupplierBackendModel with new RFXResponse
 * @param supplierBackendModel RFXSupplierBackendModel
 * @param rfxResponse RFXResponse
 */
export function updateRFXSupplierBackendModel(
  supplierBackendModel: RFXSupplierBackendModel,
  rfxResponse: RFXResponse
): RFXSupplierBackendModel {
  if (supplierBackendModel.responseId !== rfxResponse.rfxResponseRevisionedId.id.value) {
    console.error('response id not matched');
    return supplierBackendModel;
  }
  let currentSupplierModel: RFXSupplierBackendModel = cloneDeep(supplierBackendModel);
  currentSupplierModel.round = rfxResponse.rfxRequestRevisionedId.revision;
  currentSupplierModel.requestId = rfxResponse.rfxRequestRevisionedId.id.value;
  currentSupplierModel.supplier = rfxResponse.supplierId.value;
  currentSupplierModel.responseId = rfxResponse.rfxResponseRevisionedId.id.value;
  currentSupplierModel.responseVersion = rfxResponse.rfxResponseVersion;
  currentSupplierModel.responseStatus = rfxResponse.lifeCycle.lifeCycleState.name;
  currentSupplierModel.responseQuotes = convertDocumentsToQuoteEntries(rfxResponse.rfxResponseDocuments);
  currentSupplierModel.responseDocuments = convertDocuments(rfxResponse.rfxResponseDocuments).documentEntries;
  currentSupplierModel.contacts = rfxResponse.contacts ? cloneDeep(rfxResponse.contacts) : [];

  if (rfxResponse.ingestionId) {
    currentSupplierModel.ingestionId = rfxResponse.ingestionId.value;
  }
  if (rfxResponse.decisionTime) {
    currentSupplierModel.decisionTime = rfxResponse.decisionTime;
  }
  return currentSupplierModel;
}

/**
 * Converts/updates frontend model RFXResponseForm to backend model RFXResponse
 * @param supplierBackendModel RFXSupplierBackendModel
 * @param rfxRequestForm RFXRequestForm
 */
export function convertRFXResponseFormToRFXResponseBackendModel(
  supplierBackendModel: RFXSupplierBackendModel,
  rfxResponseForm: RFXResponseForm
): RFXResponse {
  if (
    supplierBackendModel.responseId &&
    supplierBackendModel.responseId !== rfxResponseForm.generalInformation.responseId!
  ) {
    console.log('RFX ID not matched. Returning original RFXRequest');
  }

  const quoteValidity = rfxResponseForm.quotes.quoteValidity;
  const workflow = supplierBackendModel.workflow ?? supplierBackendModel.requestBusinessId;

  let rfxResponse: RFXResponse = {
    rfxResponseRevisionedId: {
      id: { value: supplierBackendModel.responseId },
      revision: supplierBackendModel.round
    },
    rfxResponseVersion: supplierBackendModel.responseVersion,
    rfxRequestRevisionedId: {
      id: { value: supplierBackendModel.requestId },
      revision: supplierBackendModel.round
    },
    supplierId: { value: supplierBackendModel.supplier },
    rfxResponseClassId: { value: getRFXResponseClassId(supplierBackendModel.requestBusinessId, workflow) },
    properties: quoteValidity
      ? [createProperty(ResponsePropertyIds.QuoteValidity, quoteValidity.toString(), 'Int')]
      : [],
    rfxResponseDocuments: [],
    contacts: [],
    lifeCycle: {
      lifeCycleGraphId: 'DEFAULT_AWS_RFQ_RESPONSE',
      lifeCycleState: {
        name: convertResponseStatus(supplierBackendModel),
        version: 1
      },
      lifeCycleVersion:
        LifeCycleStateVersion[
          convertResponseStatus(supplierBackendModel).toUpperCase() as keyof typeof LifeCycleStateVersion
        ]
    }
  };

  if (supplierBackendModel.ingestionId) {
    rfxResponse.ingestionId = { value: supplierBackendModel.ingestionId! };
  }

  if (supplierBackendModel.decisionTime) {
    rfxResponse.decisionTime = supplierBackendModel.decisionTime;
  }

  let quoteFile = convertQuoteEntryToDocument(rfxResponseForm.quotes.quoteEntries);
  if (quoteFile && Object.keys(quoteFile).length > 0) {
    rfxResponse.rfxResponseDocuments.push(quoteFile);
  }

  const supplierIds: RFXIdentifier[] = [{ value: '' }]; // TODO: change to supplier as login user
  let documents = convertDocumentsToBackendModel(rfxResponseForm.documents.documentEntries, supplierIds);
  for (let i = 0; i < documents.length; ++i) {
    rfxResponse.rfxResponseDocuments.push(documents[i]);
  }

  rfxResponse.contacts = rfxResponseForm.contacts?.contacts ? cloneDeep(rfxResponseForm.contacts.contacts) : [];

  return rfxResponse;
}

/**
 * Creates a backend RFXResponse model from the Supplier view model
 * @param supplierBackendModel RFXSupplierBackendModel
 */
export function convertRFXSupplierBackendModelToRFXResponseBackendModel(supplierBackendModel: RFXSupplierBackendModel) {
  const workflow = supplierBackendModel.workflow ?? supplierBackendModel.requestBusinessId;
  let rfxResponse: RFXResponse = {
    rfxResponseRevisionedId: {
      id: { value: supplierBackendModel.responseId },
      revision: supplierBackendModel.round
    },
    rfxResponseVersion: supplierBackendModel.responseVersion,
    rfxRequestRevisionedId: {
      id: { value: supplierBackendModel.requestId },
      revision: supplierBackendModel.round
    },
    supplierId: { value: supplierBackendModel.supplier },
    rfxResponseClassId: { value: getRFXResponseClassId(supplierBackendModel.requestBusinessId, workflow) },
    properties: [],
    rfxResponseDocuments: [],
    contacts: [],
    lifeCycle: {
      lifeCycleGraphId: 'DEFAULT_AWS_RFQ_RESPONSE',
      lifeCycleState: {
        name: convertResponseStatus(supplierBackendModel),
        version: 1
      },
      lifeCycleVersion:
        LifeCycleStateVersion[
          convertResponseStatus(supplierBackendModel).toUpperCase() as keyof typeof LifeCycleStateVersion
        ]
    }
  };
  return rfxResponse;
}

function convertResponseStatus(supplierBackendModel: RFXSupplierBackendModel): string {
  return supplierBackendModel.responseStatus === '' ? 'Draft' : supplierBackendModel.responseStatus;
}

export function convertDownloadRFXResponseAttachmentOutputToQuoteEntry(
  downloadOutput: DownloadRFXResponseAttachmentOutput
): QuoteEntry {
  return {
    attachmentId: downloadOutput.attachment.externalId,
    uploadStatus:
      RFXQuotesFileUploadStatus[
        downloadOutput.attachment.status.toUpperCase() as keyof typeof RFXQuotesFileUploadStatus
      ],
    processStatus: RFXQuotesFileProcessStatus.SUBMITTED,
    version: Number(downloadOutput.attachment.version),
    uploadDate: downloadOutput.attachment.createdDate?.value || '',
    fileName: downloadOutput.attachment.filename,
    fileURL: downloadOutput.url,
    fileSize: downloadOutput.attachment.size,
    stagingS3Uri: downloadOutput.attachment.stagingS3Uri,
    report: '',
    reportURL: '',
    message: '',
    description: downloadOutput.attachment.description
  };
}

function convertQuoteEntryToDocument(quoteEntries: QuoteEntry[]): Document {
  let document: Document = {} as Document;
  if (!quoteEntries || quoteEntries.length === 0) {
    return document;
  }
  document = {
    documentType: RFXDocumentType.QUOTE,
    supplierIds: [{ value: '' }], // TODO: change to supplier as login user
    attachment: {
      externalId: quoteEntries[0].attachmentId,
      version: '' + quoteEntries[0].version,
      filename: quoteEntries[0].fileName,
      size: quoteEntries[0].fileSize,
      format: quoteEntries[0].format,
      description: quoteEntries[0].description,
      stagingS3Uri: quoteEntries[0].stagingS3Uri,
      status: quoteEntries[0].uploadStatus,
      createdDate: {
        value: quoteEntries[0].uploadDate,
        format: 'ISO_INSTANT'
      }
    }
  };
  if (quoteEntries[0].lastModifiedDate) {
    document.attachment.lastModifiedDate = {
      value: quoteEntries[0].lastModifiedDate,
      format: 'ISO_INSTANT'
    };
  }
  return document;
}

function getValidToDate(dueAt: number, quoteValidity: number): string {
  let date = new Date(dueAt);
  date.setMonth(date.getMonth() + quoteValidity);
  return date.toLocaleDateString();
}

export function convertRFXResponseToBuyerViewRespTableData(
  rfxResponses: RFXResponse[],
  rfxRequest: RFXRequest
): BUYER_VIEW_RESP_MODEL[] {
  let models: BUYER_VIEW_RESP_MODEL[] = [];
  if (!rfxResponses) {
    return [];
  }
  const hasQuoteValidity = shouldNotSkipOfferGeneration(rfxRequest.businessId?.value);

  for (let i = 0; i < rfxResponses.length; ++i) {
    let quotes = convertDocumentsToQuoteEntries(rfxResponses[i].rfxResponseDocuments);
    let documents = convertDocuments(rfxResponses[i].rfxResponseDocuments).documentEntries;
    let model: BUYER_VIEW_RESP_EVENT_MODEL = {
      rfxId: rfxResponses[i].rfxResponseRevisionedId.id.value,
      rfxRevision: rfxResponses[i].rfxResponseRevisionedId.revision,
      supplier: rfxResponses[i].supplierId.value,
      status: rfxResponses[i].lifeCycle.lifeCycleState.name,
      quotePrice: 0,
      quoteFileName: '',
      quoteFileURL: '',
      quoteCurrency: 'USD',
      quoteExternalId: '',
      quoteVersion: 0,
      supplierDocuments: documents,
      decisionTime: rfxResponses[i].decisionTime
    };
    let latestQuote = quotes[quotes.length - 1];
    if (latestQuote) {
      model.quoteFileName = latestQuote.fileName;
      model.quoteExternalId = latestQuote.attachmentId;
      model.quoteVersion = latestQuote.version;
    }
    if (hasQuoteValidity) {
      const quoteValidity = extractQuoteValidity(rfxResponses[i].properties);
      if (quoteValidity) {
        model.quoteValidity = quoteValidity;
        model.validToDate = getValidToDate(rfxRequest.dueAt, quoteValidity);
      }
    }
    models.push({ rfxEvent: model });
  }
  return models;
}
